/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { get } from "@insite/client-framework/Services/ApiService";

const apiUrl = "api/custom/recaptcha/validate";

export async function validateRecaptcha(recaptchaResponse: any): Promise<any> {
    // eslint-disable-next-line no-useless-catch
    try {
        return await get<any>(`${apiUrl}?recaptchaResponse=${recaptchaResponse}`);
    } catch (error) {
        throw error;
    }
}
